import { useEffect, useMemo, useState, Fragment } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AsyncPaginate } from "react-select-async-paginate";
// import HonestService from "../../../../services/master/HonestService";
import TransaksiService from "../../../../services/transaksi/TransaksiService";
import UserService from "../../../../services/user/UserService";
import { FaArrowLeft, FaSave, FaSpinner } from "react-icons/fa";
import MasterService from "../../../../services/master/MasterService";
import { Button, Spinner } from "react-bootstrap";
import HonestService from "../../../../services/master/HonestService";

const ViewMutu = ({ dataMutu, saveMutu, cancelMutu }) => {
    let userService = useMemo(() => new UserService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let honestService = useMemo(() => new HonestService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    // const isDisabled = localStorage.getItem("isEditStorage") === "0";

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)
    const [loadingCek, setLoadingCek] = useState(false)

    useEffect(() => {
        if (!dataMutu) return

        const getPpmMutu = async () => {
            try {
                // const jenisBudidayaOptions = [
                //     { value: "1", label: "Pembenihan" },
                //     { value: "2", label: "Budidaya" }
                // ];

                const resMutu = await userService.getUpiById(dataMutu.upiId)
                setValueUpiOpt(resMutu.data)
                setValueUpi(dataMutu.upiId)
                setValueUpiNama(dataMutu.upiNama)
                setValueUpiAlamat(dataMutu.upiAlamat)
                setValueUpiTelp(dataMutu.upiTelp)
                setValueUpiNeg(dataMutu.upiNeg)

                setValueUpiRegNo(dataMutu.upiRegNo)
                setValueUpiRegUe(dataMutu.upiNoRegUe)

                setValueDeskripsiProduk(dataMutu.mutuDesk)
                setValueAddInfo(dataMutu.addInfo)

                setValueMutuProses(dataMutu.mutuProses)
                setValueMutuTemp(dataMutu.mutuTemp)
                setValueNoSurveilance(dataMutu.mutuSurvNo)
                setValueTgSurveilance(dataMutu.mutuSurvTgl)

                const resJnsProduk = await masterService.getJenisProdukById(dataMutu.mutuJnsProduk)
                setValueJnsProdukOpt(resJnsProduk.data)

                const resTempTipe = await masterService.getTemperaturById(dataMutu.mutuTempTipe)
                setValueTempOpt(resTempTipe.data)

                // const resMutuProd = await transaksiService.listPpmMutuProdAll(dataMutu.nomorAju)
                // // console.log(resMutuProd)
                // if (Array.isArray(resMutuProd.data?.data)) {
                //     const processedData = resMutuProd.data.data.map((mutuprod) => {
                //         return {
                //             nomorAju: mutuprod.trPpkMutuProdPK.nomorAju,
                //             mutuProdSeri: mutuprod.trPpkMutuProdPK.mutuProdSeri,
                //             mutuProdNo: mutuprod.mutuProdNo,
                //             mutuProdTgl: mutuprod.mutuProdTgl,
                //         };
                //     });

                //     // Update the state with the processed data
                //     setRowsProduksi(processedData);
                // }

                // const resMutuArea = await transaksiService.listPpmMutuAreaAll(dataMutu.nomorAju)
                // if (Array.isArray(resMutuArea.data?.data)) {
                //     const processedDataArea = await Promise.all(
                //         resMutuArea.data.data.map(async (mutuarea) => {

                //             // --- Ambil Propinsi berdasarkan kode ---
                //             const prop = await masterService.getPropinsiById(mutuarea.mutuCultProp);
                //             const propObj = prop?.data || null;

                //             // --- Ambil Kota berdasarkan kode + propinsi ---
                //             const kota = await masterService.getKotaById(mutuarea.mutuCultKota);
                //             const kotaObj = kota?.data || null;

                //             // --- Mapping Jenis Budidaya dari local options ---
                //             const jenisObj = jenisBudidayaOptions.find(
                //                 j => j.value === String(mutuarea.mutuBudidayaJenis)
                //             ) || null;

                //             const wpp = await masterService.listWpp(mutuarea.mutuTangkapArea, null, 0, 10)
                //             const wppObj = wpp?.data?.data[0] || null

                //             return {
                //                 nomorAju: mutuarea.trPpkMutuAreaPK.nomorAju,
                //                 mutuAreaSeri: mutuarea.trPpkMutuAreaPK.mutuAreaSeri,
                //                 mutuArea: mutuarea.mutuArea,

                //                 // hasil mapping
                //                 mutuCultProp: propObj
                //                     ? {
                //                         kodePropinsi: propObj.kodePropinsi,
                //                         uraianPropinsi: propObj.uraianPropinsi,
                //                         uraianPropinsiEn: propObj.uraianPropinsiEn
                //                     }
                //                     : null,

                //                 mutuCultKota: kotaObj
                //                     ? {
                //                         kodePropinsi: kotaObj.kodePropinsi,
                //                         kodeKota: kotaObj.kodeKota,
                //                         uraianKota: kotaObj.uraianKota,
                //                         kodeUpt: kotaObj.kodeUpt
                //                     }
                //                     : null,

                //                 mutuBudidayaNama: mutuarea.mutuBudidayaNama,
                //                 mutuTangkapKapal: mutuarea.mutuTangkapKapal,
                //                 mutuTangkapArea: wppObj
                //                     ? {
                //                         id: wppObj.id,
                //                         wpp: wppObj.wpp,
                //                         wilayah: wppObj.wilayah
                //                     } : null,
                //                 // hasil mapping local
                //                 mutuBudidayaJenis: jenisObj,

                //                 mutuNomorSertifikat: mutuarea.mutuNomorSertifikat
                //             };
                //         })
                //     );

                //     setRowsMutuArea(processedDataArea)
                // }
            } catch (error) {
                console.log(error)
            }
        }
        getPpmMutu()
    }, [dataMutu, userService, masterService, transaksiService])

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)
    const [showHonestNoFound, setShowHonestNoFound] = useState(false)

    const [valueUpiOpt, setValueUpiOpt] = useState(null)
    const [valueUpi, setValueUpi] = useState(null)
    const [valueUpiNama, setValueUpiNama] = useState(null)
    const [valueUpiAlamat, setValueUpiAlamat] = useState(null)
    const [valueUpiTelp, setValueUpiTelp] = useState(null)
    const [valueUpiNeg, setValueUpiNeg] = useState(null)
    const [valueTempOpt, setValueTempOpt] = useState(null)
    const [valueTempId, setValueTempId] = useState(null)
    const [valueJnsProdukOpt, setValueJnsProdukOpt] = useState(null)
    const [valueJnsProdukId, setValueJnsProdukId] = useState(null)

    const [valueUpiRegNo, setValueUpiRegNo] = useState(null)
    const [valueUpiRegUe, setValueUpiRegUe] = useState(null)

    const [valueUpiHonest, setValueUpiHonest] = useState(null)
    const [valueNoSkhsHonest, setValueNoSkhsHonest] = useState(null)
    const [valueProdHonest, setValueProdHonest] = useState(null)
    const [valueGradeHonest, setValueGradeHonest] = useState(null)
    const [valueStatusHonest, setValueStatusHonest] = useState(null)
    const [valueTglStartSkhs, setValueTglStartSkhs] = useState(null)
    const [valueTglEndSkhs, setValueTglEndSkhs] = useState(null)
    const [valueTglExpired, setValueTglExpired] = useState(null)

    const [valueDeskripsiProduk, setValueDeskripsiProduk] = useState(null)
    const [valueAddInfo, setValueAddInfo] = useState(null)

    const [valueNoSurveilance, setValueNoSurveilance] = useState(null)
    const [valueTgSurveilance, setValueTgSurveilance] = useState(null)
    const [valueMutuTemp, setValueMutuTemp] = useState(null)
    const [valueMutuProses, setValueMutuProses] = useState(null)

    // const [rowsProduksi, setRowsProduksi] = useState([{ nomorAju: localStorage.getItem("nomorAjuStorage"), mutuProdSeri: 1, mutuProdNo: "", mutuProdTgl: null }])
    // const [rowsMutuArea, setRowsMutuArea] = useState([
    //     {
    //         nomorAju: localStorage.getItem("nomorAjuStorage"),
    //         mutuAreaSeri: 1,
    //         mutuArea: "",
    //         mutuCultProp: "",
    //         mutuCultKota: "",
    //         mutuTangkapArea: "",
    //         mutuBudidayaNama: "",
    //         mutuTangkapKapal: "",
    //         mutuBudidayaJenis: "",
    //         mutuNomorSertifikat: ""
    //     }
    // ])

    // const addNewRowProd = () => {
    //     const newRowsProd = { nomorAju: localStorage.getItem("nomorAjuStorage"), mutuProdSeri: rowsProduksi.length + 1, mutuProdNo: "", mutuProdTgl: null }
    //     setRowsProduksi([...rowsProduksi, newRowsProd])
    // }

    // const addNewRowArea = () => {
    //     setRowsMutuArea(prev => [
    //         ...prev,
    //         {
    //             nomorAju: localStorage.getItem("nomorAjuStorage"),
    //             mutuAreaSeri: prev.length + 1,
    //             mutuArea: "",
    //             mutuCultProp: null,
    //             mutuCultKota: null,
    //             mutuTangkapArea: null,
    //             mutuBudidayaNama: "",
    //             mutuTangkapKapal: "",
    //             mutuBudidayaJenis: null,
    //             mutuNomorSertifikat: ""
    //         }
    //     ]);
    // }

    // const removeRow = (mutuProdSeri) => {
    //     const updatedRows = rowsProduksi.filter((row) => row.mutuProdSeri !== mutuProdSeri);
    //     setRowsProduksi(updatedRows);
    // };

    // const removeRowArea = (mutuAreaSeri) => {
    //     setRowsMutuArea(prev => prev.filter(row => row.mutuAreaSeri !== mutuAreaSeri));
    // }

    // const handleInputProduksi = (mutuProdSeri, field, value) => {
    //     const updatedRowsProd = rowsProduksi.map((row) => row.mutuProdSeri === mutuProdSeri ? { ...row, [field]: value } : row)
    //     setRowsProduksi(updatedRowsProd)
    // }

    // const handleInputArea = (seri, field, value) => {
    //     setRowsMutuArea(prev =>
    //         prev.map(row => {
    //             if (row.mutuAreaSeri !== seri) return row;

    //             return {
    //                 ...row,
    //                 [field]: value,

    //                 // reset KOTA jika Propinsi berubah
    //                 ...(field === "mutuCultProp"
    //                     ? { mutuCultKota: null }
    //                     : {}),

    //                 // reset field tergantung sumber
    //                 ...(field === "mutuArea"
    //                     ? {
    //                         mutuBudidayaJenis: null,
    //                         mutuBudidayaNama: "",
    //                         mutuTangkapArea: null,
    //                         mutuTangkapKapal: ""
    //                     }
    //                     : {})
    //             };
    //         })
    //     );
    // }

    const handleChangeNoSurveilance = e => {
        setValueNoSurveilance(e.target.value)
    }

    const handleChangeTgSurveilance = e => {
        setValueTgSurveilance(e.target.value)
    }

    const handleChangeMutuTemp = e => {
        setValueMutuTemp(e.target.value)
    }

    const handleChangeMutuProses = e => {
        setValueMutuProses(e.target.value)
    }

    const onChangeNoHaccp = (e) => {
        setValueUpiRegNo(e.target.value)
    }

    const cekHaccp = async () => {
        setLoadingCek(true)
        try {
            const resHaccp = await honestService.cekHaccp(valueUpiRegNo)
            console.log(resHaccp.data.response_data[0])
            let dataHonest = resHaccp.data.response_data[0]
            if (dataHonest !== undefined) {
                // console.log(dataHonest.TGL_SKHS_END)
                setValueUpiHonest(dataHonest.UPI)
                setValueNoSkhsHonest(dataHonest.NOMOR_SKHS)
                setValueProdHonest(dataHonest.NAMA_PRODUK)
                setValueGradeHonest(dataHonest.GRADE)
                setValueStatusHonest(dataHonest.STATUS_SERT)
                setValueTglStartSkhs(dataHonest.TGL_SKHS_START.substr(0, 10))
                setValueTglEndSkhs(dataHonest.TGL_SKHS_END.substr(0, 10))
                setValueTglExpired(dataHonest.TGL_BERLAKU.substr(0, 10))
            } else {
                setShowHonestNoFound(true)
                setValueUpiHonest(null)
                setValueNoSkhsHonest(null)
                setValueProdHonest(null)
                setValueGradeHonest(null)
                setValueStatusHonest(null)
                setValueTglStartSkhs(null)
                setValueTglEndSkhs(null)
                setValueTglExpired(null)
            }
        } catch (error) {
            console.log(error)
        }
        setLoadingCek(false)
    }

    async function loadOptionJnsProduk(search, loadedOption, { page = 1 }) {
        const response = await masterService.listJenisProduk(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionUpi(search, loadedOption, { page = 1 }) {
        const response = await userService.listUpiTrader(localStorage.getItem('kodeTrader'), search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionTemperatur(search, loadedOption, { page = 1 }) {
        const response = await masterService.listTemperatur(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    // const loadOptionPropinsi = async (search, loadedOption, { page = 1 }) => {
    //     const response = await masterService.listPropinsi(search, page - 1, 10)
    //     return {
    //         options: response.data.data,
    //         hasMore: response.data.data.length >= 10,
    //         additional: {
    //             page: page + 1
    //         }
    //     }
    // }

    // const loadOptionKotaByPropinsi = seri => async (search, loadedOption, { page = 1 }) => {
    //     const row = rowsMutuArea.find(r => r.mutuAreaSeri === seri);

    //     if (!row?.mutuCultProp) {
    //         return { options: [], hasMore: false };
    //     }

    //     const response = await masterService.listKota(
    //         row.mutuCultProp.kodePropinsi,
    //         search,
    //         page - 1,
    //         10
    //     );

    //     return {
    //         options: response.data.data,
    //         hasMore: response.data.data.length >= 10,
    //         additional: { page: page + 1 }
    //     };
    // };


    // async function loadOptionWpp(search, loadedOption, { page = 1 }) {
    //     const response = await masterService.listWpp(search, search, page - 1, 10)
    //     return {
    //         options: response.data.data,
    //         hasMore: response.data.data.length >= 10,
    //         additional: {
    //             page: page + 1
    //         }
    //     }
    // }

    // async function loadOptionJenisBudidaya(search, loadedOption, { page }) {
    //     const options = [
    //         {
    //             value: '1',
    //             label: 'Pembenihan'
    //         },
    //         {
    //             value: '2',
    //             label: 'Budidaya'
    //         }
    //     ]
    //     return {
    //         options: options,
    //     }
    // }

    const onChangeOptionUpi = e => {
        setValueUpiOpt(e)
        setValueUpi(e.upiId)
        setValueUpiAlamat(e.upiAlamat)
        setValueUpiTelp(e.upiTelp)
        setValueUpiNeg(e.upiNeg)
        setValueUpiNama(e.upiNama)
        setValueUpiRegNo(e.upiRegNo)
    }

    const onChangeOptionTemperatur = e => {
        setValueTempOpt(e)
        setValueTempId(e.id)
    }

    const onChangeJnsProdukOpt = e => {
        setValueJnsProdukOpt(e)
        setValueJnsProdukId(e.id)
    }

    const onChangeUpiRegUe = e => {
        setValueUpiRegUe(e.target.value)
    }

    const onChangeDeskripsiProduk = e => {
        setValueDeskripsiProduk(e.target.value)
    }

    const onChangeAddInfo = e => {
        setValueAddInfo(e.target.value)
    }

    const [kelengkapan, setKelengkapan] = useState({})

    const checkKelengkapan = () => {
        const checkKelengkapan = {}

        if (!valueUpiOpt) checkKelengkapan.upi = 'Nama UPI Wajib Diisi'
        if (!valueDeskripsiProduk) checkKelengkapan.deskripsi = 'Deskripsi Produk Wajib Diisi'
        if (!valueJnsProdukOpt) checkKelengkapan.jenisProduk = 'Jenis Produk Wajib Diisi'
        if (!valueTempOpt) checkKelengkapan.tempTipe = 'Tipe Temperatur Wajib Diisi'
        if (!valueMutuTemp) checkKelengkapan.temp = 'Temperatur Wajib Diisi'
        if (!valueMutuProses) checkKelengkapan.proses = 'Processing Type Wajib Diisi'
        if (!valueUpiRegNo) checkKelengkapan.upiRegNo = 'Nomor Registrasi Wajib Diisi'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const handleClickSimpan = async () => {
        if (checkKelengkapan()) {
            try {
                let nomorAjuStorage = localStorage.getItem('nomorAjuStorage')
                localStorage.removeItem('dataMutuStorage')
                let dataMutuTemp = {
                    ...dataMutu,
                    mutuDesk: valueDeskripsiProduk,
                    mutuJnsProduk: valueJnsProdukId,
                    mutuProses: valueMutuProses,
                    mutuSurvNo: valueNoSurveilance,
                    mutuSurvTgl: valueTgSurveilance,
                    mutuTemp: valueMutuTemp,
                    mutuTempTipe: valueTempId,
                    nomorAju: nomorAjuStorage,
                    upiAlamat: valueUpiAlamat,
                    upiId: valueUpi,
                    upiNama: valueUpiNama,
                    upiNoRegUe: valueUpiRegUe,
                    upiRegNo: valueUpiRegNo,
                    upiTelp: valueUpiTelp,
                    addInfo: valueAddInfo
                }

                setLoadingSave(true)
                const response = await transaksiService.addPpmMutu(JSON.stringify(dataMutuTemp))
                if (response.data.kode === '200') {
                    // await transaksiService.deletePpmMutuProdByAju(localStorage.getItem("nomorAjuStorage"))
                    // rowsProduksi.map(async (rowProd) => {
                    //     let jsonMutuProd = {
                    //         trPpkMutuProdPK: {
                    //             nomorAju: localStorage.getItem("nomorAjuStorage"),
                    //             mutuProdSeri: rowProd.mutuProdSeri
                    //         },
                    //         mutuProdNo: rowProd.mutuProdNo,
                    //         mutuProdTgl: rowProd.mutuProdTgl
                    //     }
                    //     await transaksiService.addPpmMutuProd(jsonMutuProd)
                    // })

                    // await transaksiService.deletePpmMutuAreaByAju(localStorage.getItem("nomorAjuStorage"))
                    // rowsMutuArea.map(async (rowArea) => {
                    //     let jsonMutuArea = {
                    //         trPpkMutuAreaPK: {
                    //             nomorAju: localStorage.getItem("nomorAjuStorage"),
                    //             mutuAreaSeri: rowArea.mutuAreaSeri
                    //         },
                    //         mutuArea: rowArea.mutuArea,
                    //         mutuCultProp: rowArea.mutuCultProp ? rowArea.mutuCultProp.kodePropinsi : null,
                    //         mutuCultKota: rowArea.mutuCultKota ? rowArea.mutuCultKota.kodeKota : null,
                    //         mutuTangkapArea: rowArea.mutuTangkapArea ? rowArea.mutuTangkapArea.wpp : "",
                    //         mutuBudidayaNama: rowArea.mutuBudidayaNama,
                    //         mutuBudidayaJenis: rowArea.mutuBudidayaJenis ? rowArea.mutuBudidayaJenis.value : "",
                    //         mutuTangkapKapal: rowArea.mutuTangkapKapal,
                    //         mutuNomorSertifikat: rowArea.mutuNomorSertifikat
                    //     }
                    //     await transaksiService.addPpmMutuArea(jsonMutuArea)
                    // })

                    setShowSaveSucces(true)
                    setShowConfirmSave(false)
                }
                setLoadingSave(false)
            } catch (error) {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setLoadingSave(false)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setShowSaveSucces(false)
        setLoadingSave(false)
        saveMutu('mutuprod')
        localStorage.setItem('dataMutuStorage', JSON.stringify(dataMutu))
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    const handleClickNotFound = () => {
        setShowHonestNoFound(false)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data UPI</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama UPI<span className="text-danger"> *</span></label>
                                    {/* <input type="text" className="form-control" name="npwp_eksportir" placeholder="Nama UPI" /> */}
                                    <AsyncPaginate
                                        loadOptions={loadOptionUpi}
                                        value={valueUpiOpt}
                                        getOptionLabel={(option) => option.upiRegNo + '-' + option.upiNama + '-' + option.upiAlamat + '-'}
                                        getOptionValue={(option) => option.upiId}
                                        additional={{
                                            page: 1
                                        }}
                                        onChange={onChangeOptionUpi}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                </div>
                                {kelengkapan.upi && <div className="text-danger">{kelengkapan.upi}</div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Alamat</label>
                                    <textarea rows={3} className="form-control" name="alamat_eksportir" value={valueUpiAlamat} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nomor Telpon</label>
                                    <input type="text" className="form-control" name="kodepos_eksportir" placeholder="Telp" value={valueUpiTelp} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nomor Registrasi Negara Mitra / UE</label>
                                    <input type="text" className="form-control" name="kodepos_eksportir" placeholder="Nomor Registrasi Negara Mitra" value={valueUpiRegUe} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} onChange={onChangeUpiRegUe} />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-6">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Negara Asal Bahan Baku</label>
                                    <input type="text" className="form-control" name="kodepos_eksportir" placeholder="Negara Asal Bahan Baku" value={valueUpiNeg} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Produksi</h6>
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-form-label-sm">Deskripsi Produk<span className="text-danger"> *</span></label>
                            <div className="col-sm-12">
                                <textarea rows={4} className="form-control" name="alamat_penerima" value={valueDeskripsiProduk} onChange={onChangeDeskripsiProduk} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                {kelengkapan.deskripsi && <div className="text-danger">{kelengkapan.deskripsi}</div>}
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-form-label-sm">Informasi Tambahan (Additional Information)</label>
                            <div className="col-sm-12">
                                <textarea rows={4} className="form-control" name="alamat_penerima" value={valueAddInfo} onChange={onChangeAddInfo} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                            </div>
                        </div>
                        {/* <div className="row mt-3">
                            <div className="col-sm-8">
                                {localStorage.getItem('isEditStorage') !== '0' && <Button type="button" variant="btn btn-primary" size="sm" onClick={addNewRowProd}><FaPlus /> Tambah Kode Produksi</Button>}
                            </div>
                        </div> */}
                        {/* {
                            rowsProduksi.map((row) => (
                                <div className="row" key={row.mutuProdSeri}>
                                    <label className="col-sm-12 col-form-label-sm">Kode / Tanggal Produksi</label>
                                    <div className="col-sm-6">
                                        <input type="text" className="form-control" name={'kode-' + row.mutuProdNo} placeholder="Kode" value={row.mutuProdNo} onChange={(e) => handleInputProduksi(row.mutuProdSeri, "mutuProdNo", e.target.value)} />
                                    </div>
                                    <div className="col-sm-4">
                                        <input type="date" className="form-control" name={'tgl-' + row.mutuProdTgl} placeholder="Tgl" value={row.mutuProdTgl} onChange={(e) => handleInputProduksi(row.mutuProdSeri, "mutuProdTgl", e.target.value)} />
                                    </div>
                                    {localStorage.getItem('isEditStorage') !== '0' &&
                                        <div className="col-sm-2">
                                            <Button
                                                type="button"
                                                variant="btn btn-danger"
                                                size="sm"
                                                onClick={() => removeRow(row.mutuProdSeri)}
                                            >
                                                <FaX />
                                            </Button>
                                        </div>
                                    }
                                </div>

                            ))
                        } */}
                        <div className="row mt-3">
                            <label className="col-sm-12 col-form-label-sm">No / Tanggal Surveilance</label>
                            <div className="col-sm-6">
                                <input type="text" className="form-control" name="no_survey" placeholder="Nomor" value={valueNoSurveilance} onChange={handleChangeNoSurveilance} />
                            </div>
                            <div className="col-sm-4">
                                <input type="date" className="form-control" name="tgl_survey" placeholder="Tgl" value={valueTgSurveilance} onChange={handleChangeTgSurveilance} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Jenis Produk<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionJnsProduk}
                                        value={valueJnsProdukOpt}
                                        getOptionLabel={(option) => option.jenisProduk}
                                        getOptionValue={(option) => option.id}
                                        additional={{
                                            page: 1
                                        }}
                                        onChange={onChangeJnsProdukOpt}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.jenisProduk && <div className="text-danger">{kelengkapan.jenisProduk}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Temperatur<span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control" name="temperatur" placeholder="Temperatur" value={valueMutuTemp} onChange={handleChangeMutuTemp} />
                                    {kelengkapan.temp && <div className="text-danger">{kelengkapan.temp}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Jenis Temperatur<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionTemperatur}
                                        value={valueTempOpt}
                                        getOptionLabel={(option) => option.jnsTemperature}
                                        getOptionValue={(option) => option.id}
                                        additional={{
                                            page: 1
                                        }}
                                        onChange={onChangeOptionTemperatur}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                </div>
                                {kelengkapan.tempTipe && <div className="text-danger">{kelengkapan.tempTipe}</div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Processing Type<span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control" name="processing_type" placeholder="Processing Type" value={valueMutuProses} onChange={handleChangeMutuProses} />
                                    {kelengkapan.proses && <div className="text-danger">{kelengkapan.proses}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row mb-3">
                            <label className="col-form-label-sm">Nomor Registrasi (HACCP/SKP/No Reg Mitra Non UE)<span className="text-danger"> *</span></label>
                            <div className="col-sm-8">
                                <input type="text" className="form-control-sm" name="nomor_haccp" placeholder="Nomor HACCP" value={valueUpiRegNo} onChange={onChangeNoHaccp} />{' '}
                                <Button type="button" size="sm" variant="outline-primary" onClick={() => cekHaccp()} disabled={loadingCek} >{loadingCek && <FaSpinner />} Cek Validitas HACCP</Button>
                            </div>
                            {kelengkapan.upiRegNo && <div className="text-danger">{kelengkapan.upiRegNo}</div>}
                        </div>
                        <div className="row mb-3">
                            <div className="col-8">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama UPI (Honest)</label>
                                    <input type="text" className="form-control-sm col-12" name="upi_honest" placeholder="Nama UPI" value={valueUpiHonest} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Grade</label>
                                    <input type="text" className="form-control-sm" name="upi_grade" placeholder="Grade" value={valueGradeHonest} readOnly />
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Status</label>
                                    <input type="text" className="form-control-sm col-12" name="upi_status" placeholder="Status" value={valueStatusHonest} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-form-label-sm">Nomor SKHS (Honest)</label>
                            <div className="col-sm-6">
                                <input type="text" className="form-control" name="nomor_haccp" placeholder="No SKHS" value={valueNoSkhsHonest} readOnly />
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-sm-12 col-form-label-sm">Tanggal Awal/Akhir SKHS (Honest)</label>
                            <div className="col-sm-3">
                                <input type="date" className="form-control" name="tgl_start" placeholder="Tgl Start" value={valueTglStartSkhs} readOnly />
                            </div> -
                            <div className="col-sm-3">
                                <input type="date" className="form-control" name="tgl_end" placeholder="Tgl End" value={valueTglEndSkhs} readOnly />
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-sm-12 col-form-label-sm">Tanggal Kadaluarsa (Honest)</label>
                            <div className="col-sm-3">
                                <input type="date" className="form-control" name="tgl_berlaku" placeholder="Tgl Start" value={valueTglExpired} readOnly />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-sm-8">
                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label-sm">Nama Produk (Honest)</label>
                                    <input type="text" className="form-control col-12" name="nmproduk_haccp" placeholder="Tgl Start" value={valueProdHonest} readOnly />
                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Sumber Produk</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-8">
                                {localStorage.getItem('isEditStorage') !== '0' && <Button type="button" variant="btn btn-primary" size="sm" onClick={addNewRowArea}><FaPlus /> Tambah</Button>}
                            </div>
                        </div>
                        {
                            rowsMutuArea.map((row, idx) => (
                                <Fragment key={row.mutuAreaSeri}>
                                    <div className="row mb-3">
                                        <label className="col-form-label-sm"><b>{idx + 1}. Sumber</b></label>
                                        <div className="col-sm-10">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name={`radioSumber-${row.mutuAreaSeri}`}
                                                    id={`radioSumber-${row.mutuAreaSeri}-1`}
                                                    value="1"
                                                    checked={row.mutuArea === "1"}
                                                    onChange={e =>
                                                        handleInputArea(row.mutuAreaSeri, "mutuArea", e.target.value)
                                                    }
                                                    disabled={isDisabled}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`radioSumber-${row.mutuAreaSeri}-1`}
                                                >
                                                    Aqua Cultured / Area Cultured
                                                </label>
                                            </div>

                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name={`radioSumber-${row.mutuAreaSeri}`}
                                                    id={`radioSumber-${row.mutuAreaSeri}-2`}
                                                    value="2"
                                                    checked={row.mutuArea === "2"}
                                                    onChange={e =>
                                                        handleInputArea(row.mutuAreaSeri, "mutuArea", e.target.value)
                                                    }
                                                    disabled={isDisabled}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`radioSumber-${row.mutuAreaSeri}-2`}
                                                >
                                                    Wild Cought / Area Tangkap
                                                </label>
                                            </div>
                                        </div>
                                        {!isDisabled &&
                                            <div className="col-sm-2">
                                                <Button
                                                    type="button"
                                                    variant="btn btn-danger"
                                                    size="sm"
                                                    onClick={() => removeRowArea(row.mutuAreaSeri)}
                                                >
                                                    <FaX />
                                                </Button>
                                            </div>
                                        }
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-form-label-sm">Propinsi</label>
                                        <div className="col-sm-8">
                                            <AsyncPaginate
                                                loadOptions={loadOptionPropinsi}
                                                value={row.mutuCultProp}
                                                onChange={v =>
                                                    handleInputArea(row.mutuAreaSeri, "mutuCultProp", v)
                                                }
                                                getOptionLabel={o => o?.uraianPropinsi}
                                                getOptionValue={o => o?.kodePropinsi}
                                                additional={{ page: 1 }}
                                                isDisabled={isDisabled}
                                            />
                                        </div>
                                        <label className="col-form-label-sm">Kota</label>
                                        <div className="col-sm-8">
                                            <AsyncPaginate
                                                loadOptions={loadOptionKotaByPropinsi(row.mutuAreaSeri)}
                                                value={row.mutuCultKota}
                                                onChange={v =>
                                                    handleInputArea(row.mutuAreaSeri, "mutuCultKota", v)
                                                }
                                                getOptionLabel={o => o?.uraianKota}
                                                getOptionValue={o => o?.kodeKota}
                                                additional={{ page: 1 }}
                                                isDisabled={isDisabled || !row.mutuCultProp}
                                            />
                                        </div>
                                    </div>
                                    {
                                        row.mutuArea === '1' &&
                                        <>
                                            <div className="row mb-3">
                                                <label className="col-form-label-sm">Jenis Budidaya</label>
                                                <div className="col-sm-6">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionJenisBudidaya}
                                                        value={row.mutuBudidayaJenis}
                                                        onChange={v =>
                                                            handleInputArea(
                                                                row.mutuAreaSeri,
                                                                "mutuBudidayaJenis",
                                                                v
                                                            )
                                                        }
                                                        getOptionLabel={o => o?.label}
                                                        getOptionValue={o => o?.value}
                                                        additional={{ page: 1 }}
                                                        isDisabled={isDisabled}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-form-label-sm">Nama Pembudidaya / Tambak</label>
                                                <div className="col-sm-12">
                                                    <textarea
                                                        rows={5}
                                                        className="form-control"
                                                        placeholder="Nama Pembudidaya / Tambak"
                                                        value={row.mutuBudidayaNama}
                                                        onChange={e =>
                                                            handleInputArea(
                                                                row.mutuAreaSeri,
                                                                "mutuBudidayaNama",
                                                                e.target.value
                                                            )
                                                        }
                                                        disabled={isDisabled}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {
                                        row.mutuArea === '2' &&
                                        <>
                                            <div className="row mb-3">
                                                <label className="col-form-label-sm">WPP</label>
                                                <div className="col-sm-6">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionWpp}
                                                        value={row.mutuTangkapArea}
                                                        onChange={v =>
                                                            handleInputArea(
                                                                row.mutuAreaSeri,
                                                                "mutuTangkapArea",
                                                                v
                                                            )
                                                        }
                                                        getOptionLabel={o =>
                                                            `${o?.wpp} - ${o?.wilayah}`
                                                        }
                                                        getOptionValue={o => o?.wpp}
                                                        additional={{ page: 1 }}
                                                        isDisabled={isDisabled}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-form-label-sm">
                                                    Nama Kapal Pengolah / Tangkap
                                                </label>
                                                <div className="col-sm-12">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nama Kapal"
                                                        value={row.mutuTangkapKapal}
                                                        onChange={e =>
                                                            handleInputArea(
                                                                row.mutuAreaSeri,
                                                                "mutuTangkapKapal",
                                                                e.target.value
                                                            )
                                                        }
                                                        disabled={isDisabled}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className="row mb-3">
                                        <label className="col-form-label-sm">Nomor Sertifikat CPIB/CBIB/CPIB Kapal</label>
                                        <div className="col-sm-12">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Nomor Sertifikat CPIB/CBIB/CPIB Kapal"
                                                value={row.mutuNomorSertifikat}
                                                onChange={e =>
                                                    handleInputArea(
                                                        row.mutuAreaSeri,
                                                        "mutuNomorSertifikat",
                                                        e.target.value
                                                    )
                                                }
                                                disabled={isDisabled}
                                            />
                                        </div>
                                    </div>
                                </Fragment>
                            ))
                        } */}
                    </div>
                </div>
                {
                    localStorage.getItem('isEditStorage') === '1' ? <>
                        <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={handleShowConfirmSave} ><FaSave /> Simpan & Lanjutkan</button>
                        <button type="button" name="back" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Kembali" onClick={() => cancelMutu('komoditi')} ><FaArrowLeft /> Sebelumnya</button>
                    </> : ''
                }
            </div >
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Mutu?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Mutu Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Mutu Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showHonestNoFound &&
                <SweetAlert
                    danger
                    title="Nomor Tidak Ditemukan Pada Sistem Honest"
                    onConfirm={handleClickNotFound}
                    btnSize="sm"
                    timeout={5000}
                />
            }
        </>
    )
}

export default ViewMutu